'use client'

import { useTranslation } from 'react-i18next'
import { LocaleSwitcherEntry } from 'tsconfig/craft-types'
import { CLocaleSwitcherContent } from './c-locale-switcher-content'

type Props = {
  domain: string
  entry?: LocaleSwitcherEntry
}

export const CLocaleSwitcherBody = ({ domain, entry }: Props) => {
  const { t } = useTranslation('common')

  return (
    <CLocaleSwitcherContent
      domain={domain}
      entry={entry}
      title={entry?.title || t('select-your-region')}
    />
  )
}
